import queries from '@apis/queries';
import MyShopApi from '@apis/shop/MyShopApi';
import useUser from '@hooks/auth/useUser';
import useToast from '@hooks/ui/useToast';
import { ShopResponse } from '@models/shop';
import { useMutation, useQueryClient } from '@tanstack/react-query';

function useToggleMyShop(shop?: ShopResponse) {
  const toast = useToast();
  const { user } = useUser();
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: MyShopApi.toggleMyShop,
    async onSuccess() {
      queryClient.invalidateQueries({ queryKey: queries.shop._def });
      toast.info(`MY 매장${!shop?.isMyShop ? '에 등록되었습니다.' : '이 해제되었습니다.'}`);
    },
    onError(e) {
      console.error(e);
      toast.error('MY 매장 등록에 실패했습니다.');
    },
  });
  const toggleMyShop = () => {
    if (!user) {
      toast.error('로그인이 필요합니다.');
      return;
    }
    if (!shop) {
      toast.error('매장 정보가 없습니다.');
      return;
    }
    mutate(shop.id);
  };
  return {
    toggleMyShop,
  };
}

export default useToggleMyShop;
